export default {
  // Product modal state
  showProductStatusModal: null,

  // Product row IDs
  singleProductDeleteRowId: null,
  singleProductImageUploadRowId: null,

  // Product list state
  productListActiveTab: "on_sale",

  // Product data
  productsData: null,

  // Product detail state
  productDetail: {
    data: null,
    loading: false,
    error: null,
  },

  // Product safety info state
  productSafetyInfo: {
    data: null,
    loading: false,
    error: null,
  },

  // Loading states
  isLoading: {
    products: false,
    productInfo: false,
    productImages: false,
    productUpload: false,
    productTemplate: false,
  },

  // Error states
  errors: {
    products: null,
    productInfo: null,
    productImages: null,
    productUpload: null,
    productTemplate: null,
  },

  // Product update state
  isPriceAreaUpdate: false,
  activePopoverId: null,
  isPriceAreaStatus: null,
  isPriceAreaErrorMessage: null,

   subTabsByKey: {},

  // Product model code state
  productModelCode: {
    data: null,
    loading: false,
    error: null,
  },

  // Product additional info state
  productAdditionalInfo: {
    data: null,
    loading: false,
    error: null,
  },

  productSaleVariant: {
    data: null,
    loading: false,
    error: null,
  },
  
  productDescription: {
    data: null,
    loading: false,
    error: null,
  },
};
